import { useCallback, type MouseEvent } from 'react';

export function useShineClick<T extends HTMLElement>() {
  return useCallback((event: MouseEvent<T>) => {
    const element = event.currentTarget;
    element.classList.remove('is-shine');
    void element.offsetWidth;
    element.classList.add('is-shine');
    window.setTimeout(() => element.classList.remove('is-shine'), 600);
  }, []);
}
